
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface FormActionsProps {
  isPending: boolean;
  onCancel?: () => void;
  submitLabel?: string;
  loadingLabel?: string;
}

const FormActions = ({ 
  isPending, 
  onCancel, 
  submitLabel = '게시하기', 
  loadingLabel = '게시 중...' 
}: FormActionsProps) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex justify-end space-x-4 pt-4 mt-16">
      <Button 
        type="button" 
        variant="outline" 
        onClick={handleCancel}
        disabled={isPending}
      >
        취소
      </Button>
      <Button 
        type="submit" 
        disabled={isPending}
      >
        {isPending ? loadingLabel : submitLabel}
      </Button>
    </div>
  );
};

export default FormActions;
